import { ApolloClient, ApolloLink, InMemoryCache, createHttpLink, split } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { createClient } from 'graphql-ws';
import { getMainDefinition } from '@apollo/client/utilities';

const SETU_ID = process.env.REACT_APP_SETU_ID ?? 'studentsetu';

const setuLink = new ApolloLink((operation, forward) => {
  operation.setContext(({ headers }) => ({
    headers: { ...headers, 'X-Setu-Id': SETU_ID },
  }));
  return forward(operation);
});

// In production (Netlify), REACT_APP_API_URL is set to the Railway server URL.
// In dev, we use a relative path so CRA's proxy (package.json → proxy) forwards to :4000.
const API_URL = process.env.REACT_APP_API_URL || '';
const WS_URL  = process.env.REACT_APP_WS_URL
  || `ws://${window.location.hostname}:4000/graphql`;

const httpLink = createHttpLink({ uri: API_URL ? `${API_URL}/graphql` : '/graphql' });

const authLink = setContext((_, { headers }) => {
  // Priority: super admin → company → admin → university → teacher → mentor → student
  const superAdminToken  = localStorage.getItem('g2u_super_admin_token');
  const companyToken     = localStorage.getItem('g2u_company_token');
  const adminToken       = localStorage.getItem('g2u_admin_token');
  const universityToken  = localStorage.getItem('g2u_university_token');
  const teacherToken     = localStorage.getItem('g2u_teacher_token');
  const mentorToken      = localStorage.getItem('g2u_mentor_token');
  const studentToken     = localStorage.getItem('g2u_token');
  const token = superAdminToken || companyToken || adminToken || universityToken || teacherToken || mentorToken || studentToken;
  return {
    headers: { ...headers, ...(token ? { Authorization: `Bearer ${token}` } : {}) }
  };
});

const wsLink = new GraphQLWsLink(createClient({
  url: WS_URL,
  connectionParams: () => {
    const token = localStorage.getItem('g2u_token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  }
}));

const errorLink = onError(() => {});

const splitLink = split(
  ({ query }) => {
    const def = getMainDefinition(query);
    return def.kind === 'OperationDefinition' && def.operation === 'subscription';
  },
  wsLink,
  setuLink.concat(errorLink.concat(authLink.concat(httpLink)))
);

export const client = new ApolloClient({
  link: splitLink,
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: { errorPolicy: 'all' },
    query:      { errorPolicy: 'all' },
    mutate:     { errorPolicy: 'all' },
  },
});
